"use strict";
angular.module("spreadsheets").classy.controller({
    name: "SpreadsheetsController",
    inject: [
        "$scope", "authServiceFactory", "SpreadsheetsService",
        "SpreadsheetModelService", "AskSchoolSpecificQuestionsModelService", "$http", "$modal"
    ],
    init: function() {

        this.$.SpreadsheetModelService = this.SpreadsheetModelService;
        this.$.SpreadsheetsService = this.SpreadsheetsService;
        this.$.SpreadsheetsService.resetSpreadsheet();
        let self = this;
        this.$.sortableOptions = {
            axis: "y",
            stop: function() {

                for (let i = 0; i < self.SpreadsheetsService._list.length; i++) {
                    self.SpreadsheetsService._list[i].order = i;
                }
            }
        };
    },

    initDownloadModal: function() {
        let ssservice = this.SpreadsheetsService;
        let path = "fast/submodules/schoolside/reports/submodules/spreadsheets/partials/downloadReportsModal.html";
        return this.$modal.open({
            templateUrl: `${path}?v=${versionNo}`,
            controller: "DownloadReportModalsController",
            resolve: {
                item: function() {
                    return {
                        id: ssservice._id,
                        type: ssservice._type,
                        name: ssservice._name
                    };
                }
            }
        });
    },
    submit: function(scope, instance, form) {

        let ssservice = this.SpreadsheetsService;
        let payload = {};
        let parent = this;
        payload.recordID = this.SpreadsheetsService._id;
        payload.name = this.SpreadsheetsService._name;
        payload.type = this.SpreadsheetsService._type;
        payload.columns = this.SpreadsheetsService.getList();
        payload.deleted = 0;
        if (form.$valid) {

            instance.options.factor  = 0.3;
            if (payload.recordID !== null) {
                return this.$http.put(
                    "api/school/" + this.authServiceFactory.getAuth().schoolID + "/spreadsheetDB/" + payload.recordID,
                    payload
                ).success((data, status, headers, config) => {
                    instance.options.callMe(data, status, headers, config, instance);
                    ssservice.setDirty(false);
                });
            } else {

                for (let i = 0; i < payload.columns.length; i++) {
                    payload.columns[i].order =  i.toString();
                }

                return this.$http.post(
                    "api/school/" + this.authServiceFactory.getAuth().schoolID + "/spreadsheetDB", payload
                ).success((data, status, headers, config) => {
                    instance.options.callMe(data, status, headers, config, instance);
                    ssservice._id = data.id;
                    ssservice.setDirty(false);
                    payload.recordID = data.id;
                    parent.SpreadsheetsService.newItem(payload);
                });
            }
        } else {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) {
        instance.stop(1);
        if (typeof callback !== "undefined") {
            callback();
        }
    }

});
